export interface MultiSelect {
    id: string;
    name: string;
}
